/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('../bootstrap');
require('../axios');
require('../plugins');

window.lightbox = require('lightbox2');

//window.Vue = require('vue').default;
import Vue from 'vue';
import router from './router';
import App from './layouts/App.vue';

import VueMeta from 'vue-meta'
import ScrollLink from './components/ScrollLink';
import Loading from 'vue-loading-overlay';

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

/* const files = require.context('./', true, /\.vue$/i)
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default)) */

Vue.component('ScrollLink', ScrollLink);
Vue.component('Loading', Loading);
Vue.use(VueMeta);
/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    router,
    el: '#app',
    render: h => h(App),
});
